export const GenderTexts: Record<string, string> = {
  "male": "Laki-laki",
  "female": "Perempuan",
  "other": "Laki-laki / Perempuan",
  "10": "Laki-laki",
  "20": "Perempuan",
}

export const MaritalStatusTexts = {
  "single": "Belum menikah",
  "married": "Telah menikah",
  "widower": "Cerai hidup",
  "widow": "Cerai hidup",
  "divorced": "Cerai hidup",
  "death_divorced": "Cerai mati",
  "other": "Tidak ada preferensi",
}

export const PhysicalTexts = {
  "normal": "Non disabilitas",
  10: "Non disabilitas",
  "disability": "Disabilitas",
  "disabled": "Disabilitas",
  20: "Disabilitas",
  "other": "Disabilitas & Non disabilitas",
}